import type { ReactElement } from 'react';
import { cn } from '@/lib/cn';

type FilterOption = {
  id: string;
  label: string;
};

type Props = {
  options: FilterOption[];
  selected: string | null;
  onSelect: (id: string | null) => void;
};

function chipClasses(active: boolean): string {
  return cn(
    'h-9 px-4 rounded-[var(--r-sm)] text-[12px] font-semibold transition-colors whitespace-nowrap',
    'border',
    active
      ? 'bg-[var(--ink)] text-[var(--bg-surface)] border-[var(--ink)]'
      : 'bg-[var(--bg-surface)] text-[var(--ink-2)] border-[var(--rule)] hover:border-[var(--rule-strong)]',
  );
}

export function FilterChips({ options, selected, onSelect }: Props): ReactElement {
  return (
    <div className="flex gap-2 overflow-x-auto scrollbar-none pb-1">
      <button type="button" onClick={() => onSelect(null)} className={chipClasses(selected === null)}>
        All
      </button>
      {options.map((opt) => (
        <button
          key={opt.id}
          type="button"
          onClick={() => onSelect(opt.id)}
          className={chipClasses(selected === opt.id)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
